import { __rest, __assign } from '../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { ReactComponent as SvgSelectArrowMid } from './svg/select-arrow-mid.svg.js';

/**
 * @deprecated - use ArrowUpDown.
 *
 * @param {boolean} legacyBoundingBox - (optional) This prop has no effect on legacy icons with the Mid or Small name suffix.
 * @param {number} size - (optional) This prop has no effect on legacy icons with the Mid or Small name suffix.
 * @param {string} title - (optional) will be applied as `aria-label` unless an `aria-label` is explicitly set.
 */
var SelectArrowMid = function (props) {
    var title = props.title; props.size; props.legacyBoundingBox; var rest = __rest(props, ["title", "size", "legacyBoundingBox"]);
    return (jsx(SvgSelectArrowMid, __assign({ viewBox: "-1.33 -1.33 26.66 26.66", "aria-label": title, role: "img" }, rest, { width: 24, height: 24, "data-pp-icon": "SelectArrowMid" })));
};

export { SelectArrowMid as default };
//# sourceMappingURL=SelectArrowMid.js.map
